import { buildHairRecommendationInputs } from './hairRecommendationInputs';

export const CATEGORY_COLORS = {
  'Dandruff': '#3b82f6',
  'Thinning Stage 1': '#a78bfa',
  'Thinning Stage 2': '#8b5cf6',
  'Thinning Stage 3': '#7c3aed',
  'Thinning Stage 4': '#6d28d9',
  'Spot Baldness': '#1e293b',
  'Baldness': '#1e293b',
  'Scalp Rash': '#ef4444',
  'Scalp Pimples': '#ec4899',
  'Greasy Hair': '#10b981',
  'Thick Scaling': '#d97706',
  'Rough/Straw Hair': '#f59e0b',
  'Silver/White Hair': '#6B8E23',
  'Hair Bugs': '#dc2626',
  'Ginger/Copper Hair': '#ea580c',
};

export const VIEW_ORDER = ['crown', 'left'];

export const isDefaultDummyProduct = (p) => {
  if (!p) return false;
  const name = (p.product_name || p.name || '').toLowerCase();
  return name.includes('scalp revitalizing') || name.includes('anti-frizz') || name.includes('silk oil');
};

/** Broad product-catalog concerns (legacy DB); not used for salon price-list tags. */
export const mapDetectionToDbConcern = (label) => {
  if (!label) return null;
  const l = label.toLowerCase();
  if (l.includes('dandruff') || l.includes('scaling')) return 'Dandruff';
  if (l.includes('greasy') || l.includes('oil')) return 'Greasy / Oily Hair';
  if (l.includes('thinning') || l.includes('bald') || l.includes('recession') || l.includes('hairline')) return 'Thinning Hair';
  if (l.includes('silver') || l.includes('white') || l.includes('grey') || l.includes('gray')) return 'Grey Hair';
  return null;
};

export const mapConditionToDbConcern = mapDetectionToDbConcern;

/** Build salon API payload: lower scores = worse concerns (matches skin recommender). */
export function extractHairConcernScores(hairResults) {
  return buildHairRecommendationInputs(hairResults || {});
}

export const pickNonemptyDetections = (...sources) => {
  for (const list of sources) {
    if (Array.isArray(list) && list.length > 0) return list;
  }
  return [];
};

export const getViewWithMostDetections = (hairResults) => {
  if (!hairResults) return 'crown';
  const positionResults = hairResults.position_results || hairResults.positionResults || {};
  let bestView = 'crown';
  let bestCount = -1;
  for (const view of VIEW_ORDER) {
    const count = pickNonemptyDetections(
      positionResults[view]?.results?.detections,
      positionResults[view]?.detections
    ).length;
    if (count > bestCount) {
      bestCount = count;
      bestView = view;
    }
  }
  return bestView;
};

export const buildClientRoutineShowcase = (morning = [], evening = [], hairResults = null) => {
  const concernOrder = [];
  const dets = hairResults?.results?.all_detections || hairResults?.detections || [];
  dets.forEach((d) => {
    const concern = mapDetectionToDbConcern(d.label);
    if (concern && !concernOrder.includes(concern)) concernOrder.push(concern);
  });
  if (!concernOrder.length) concernOrder.push('Thinning Hair');

  const byConcern = {};
  [...morning, ...evening].forEach((p) => {
    const concern = p.hair_problem || 'General Care';
    if (!byConcern[concern]) byConcern[concern] = [];
    if (!byConcern[concern].some((item) => item.product_id === p.product_id)) {
      byConcern[concern].push(p);
    }
  });

  const showcase = [];
  const cursor = {};
  concernOrder.forEach((c) => { cursor[c] = 0; });

  while (showcase.length < 4) {
    let added = false;
    for (const concern of concernOrder) {
      const products = byConcern[concern] || [];
      const idx = cursor[concern] || 0;
      if (idx >= products.length) continue;
      showcase.push(products[idx]);
      cursor[concern] = idx + 1;
      added = true;
      if (showcase.length >= 4) break;
    }
    if (!added) break;
  }

  return showcase.filter((p) => !isDefaultDummyProduct(p));
};
